import React from 'react';
import TablaExpMinas from '../components/minas/tablaExpMinas';

  function Expeminas() {
    return (
        <div className='col-12 d-flex justify-content-center row p-0 m-0'>
          <TablaExpMinas />
        </div>
    );
  }

  export default Expeminas;




// WEBPACK FOOTER //
// ./src/pages/expeminas.js